import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ArticleEditorLayout } from "@/components/stealth-writer/result";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";

export const Route = createFileRoute("/_app/content-enhancer")({
  component: RouteComponent,
  async loader({ context: { queryClient } }) {
    await queryClient.prefetchQuery(userPlanQueryOptions);
  },
  staticData: {
    title: "Content Enhancer",
  },
  head: () => ({
    meta: [
      {
        name: "description",
        content:
          "Improve structure, style, and readability of any draft with Polygraf AI’s Content Enhancer - AI-powered suggestions to sharpen messaging and engagement, deployable in local or on-premises environments.",
      },
    ],
  }),
});

function RouteComponent() {
  const plan = useSuspenseQuery(userPlanQueryOptions);

  // TODO: get @jmlhsynv to handle missing plan info in case of expired free plan
  return (
    <ArticleEditorLayout
      result={null}
      enhancer={true}
      plan={plan.data.info!}
      entry_type="CONTENT_ENHANCER"
    />
  );
}
